import { Numeral } from "../../../../components/Numeral"

interface WalletCardProps {
  title: string,
  token: string,
  chainType?: string,
  accountNo?: string,
  balance?: number,
  onClick?: () => void,
  onClickTransfer?: () => void
}
export const WalletCard = ({ title, token, accountNo, balance, chainType, onClick, onClickTransfer }: WalletCardProps) => {
  return (
    <>
      <div
        className="
        bg-white
          p-3
          m-0 m-sm-3
          mb-3 cursor-pointer
          hover:shadow-2xl
          hover:border
          text-break
          rounded-md
          w-100
        "
        style={{ maxWidth: '400px', minWidth: '250px' }}
        onClick={onClick}
      >
        <div className="d-flex justify-between">
          <div className="d-flex">
            <img src={require(`../../../../assets/img/nft/wallet/${token.toLocaleLowerCase()}.png`)} alt="icon" className="me-2" style={{ height: '20px' }} />
            <div className="weight-600">{title}{chainType ? (<span className="weight-500 txt-12"> / {chainType}</span>) : ''}</div>
          </div>
          <div className="text-xl">$ <Numeral value={balance || 0} /></div>
        </div>
        <div className="d-flex justify-between align-items-baseline" onClick={onClickTransfer}>
          <div className="pt-3 txt-12">帳戶/位址</div>
          <div className="btn-wallet txt-12">{token === 'GAS' ? '充值/' : ''}{token === 'NNEGO' ? '提領/' : ''}轉帳/收款</div>
        </div>
        <div className="txt-12">{accountNo || ""}</div>
      </div>
    </>
  )
}